import styled from 'styled-components';
import { UIButtonToEdit } from '../../../UI';

export const Option = styled(UIButtonToEdit)`
  margin-bottom: 20px;
`;
